import {SET_QUERY_PARAMS, UPDATE_QUERY_PARAM} from '../../actions/queryParamsAction';
const queryParamsReducer = (state = {
},action) => {
    switch(action.type) {
        case SET_QUERY_PARAMS: {
            return {
                 ...action.payload
            }
        }
        case UPDATE_QUERY_PARAM: {
          return{
            ...state,
            ...action.payload
          }
        }
        break;
        default :{
            break;
          }
    }
    return state;
}

export default queryParamsReducer;
